/* tslint:disable */
/* eslint-disable */
/**
 * Magnolia Headless Helper API
 * Helper API and model definitions for breadcrumbs page navigation etc. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
* 
* @export
* @interface ApiFormSubmitRequest
*/
export interface ApiFormSubmitRequest {
    /**
    * 
    * @type {string}
    * @memberof ApiFormSubmitRequest
    */
    formId: string;
    /**
    * 
    * @type {{ [key: string]: object; }}
    * @memberof ApiFormSubmitRequest
    */
    formData: { [key: string]: object; };
    /**
    * 
    * @type {string}
    * @memberof ApiFormSubmitRequest
    */
    locale?: string;
}

export function ApiFormSubmitRequestFromJSON(json: any): ApiFormSubmitRequest {
return ApiFormSubmitRequestFromJSONTyped(json, false);
}

export function ApiFormSubmitRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiFormSubmitRequest {
    if ((json === undefined) || (json === null)) {
    return json;
    }
    return {
    
                    'formId': json['formId'],
                    'formData': json['formData'],
                    'locale': json['locale'],
        };
    }

    export function ApiFormSubmitRequestToJSON(value?: ApiFormSubmitRequest | null): any {
    if (value === undefined) {
    return undefined;
    }
    if (value === null) {
    return null;
    }
    return {

                'formId': value.formId,
                'formData': value.formData,
                'locale': value.locale,
    };
    }


    // custom code here ##################################################################################################################
    // function toUTC(date) {
    //   var date_utc =  Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
    //   return new Date(date_utc);
    // }

